import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { RolesRequestList } from '../../../../../models/api-user/roles/roles.request.model';
import { UsersRequest } from '../../../../../models/users/users.request.model';
import { RolesService } from '../../../../../services/api-user/roles/roles.service';
import { SpinnerService } from '../../../../../services/spinner/spinner.service';
import { UserService } from '../../../../../services/user/user.service';
import { TRUE } from '../../../../../utils/config/const';

@Component({
  selector: 'app-user-create',
  templateUrl: './user-create.component.html'
})
export class UserCreateComponent implements OnInit {


  formBuilder: FormGroup;
  request:any = {};
  isButtonSaveDisabled:boolean;
  roles:any = [];
  
  constructor(
    public activeModal: NgbActiveModal,
    private fb: FormBuilder,
    private spinner: SpinnerService,
    private userService: UserService,
    private rolesService: RolesService,
    private toastr: ToastrService,
  ) { 
    this.initForm();
  }

  ngOnInit(): void {
    this.loadRoles();
  }


  loadRoles(){
    this.spinner.show();
    let request = new RolesRequestList();
    request.pageNumber = 0;
    request.pageSize = 50;
    this.rolesService.getList(request).subscribe(
      (response) => {
        if (response) {
          this.roles = response.data;
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.toastr.error('Si è verificato un errore durante il caricamento delle informazioni del header', 'Load header', {
          timeOut: 5000
        });
        this.spinner.hide();
      }
    );
  }

  get form(){return this.formBuilder;}
  get formControls() { return this.formBuilder.controls; }

  initForm(){
    this.formBuilder = this.fb.group({
      name: ['',[Validators.required]],
      surname: ['',[Validators.required]],
      email: ['',[Validators.required]],
      role: ['',[Validators.required]],
      enabled: [ true,[Validators.required]],
      note: ['']
    });
    this.isButtonSaveDisabled = false;
  }

  getValue(){
    let request = new UsersRequest();
    request.email = this.formBuilder.controls['email'].value;
    request.enabled = this.formBuilder.controls['enabled'].value;
    request.name = this.formBuilder.controls['name'].value;
    request.note = this.formBuilder.controls['note'].value;

    let roleObj = null;
    for (let role of this.roles) {
      if(this.formBuilder.controls['role'].value == role.id){
        roleObj = role;
      }
    }
    if(roleObj != null){
      request.role = [];
      request.role.push(roleObj);
    }

    request.surname = this.formBuilder.controls['surname'].value;
    return request;
  }

  save(){
    this.request = this. getValue();
    this.userService.create(this.request).subscribe(
      (response) => {
        if(response){
          //Salvato
          this.toastr.success('Creato con successo', 'Crea utente');
          this.isButtonSaveDisabled = true;
          this.activeModal.close(response);
        }
      },
      (error: HttpErrorResponse) => {
        this.isButtonSaveDisabled = true;
        this.toastr.error('Si è verificato un errore durante la creazione' , 'Crea utente fallita', {
            timeOut: 5000
        });
      }
    );
  }

  clickButtonSave(){
    if(this.formBuilder.status === 'VALID' && this.formBuilder.touched == TRUE){
      this.isButtonSaveDisabled = true;
      this.save();
    }
  }

  clickButtonCancel() {
    this.activeModal.close('CLOSE');
  }
}
